<template>
  <div class="sl-container">
    <div class="row justify-content-center" v-if="serviceLines">
      <div class="col-12">
        <div>
          <button
            class="navbar-toggler mb-2 mt-2 toggle-sl-button d-block d-sm-block d-md-none"
            type="button"
            data-toggle="collapse"
            data-target="#navbarNav"
            aria-controls="navbarNav"
            aria-expanded="false"
            aria-label="Toggle navigation"
            ref="navbarToggler"
          >
            <img src="../../assets/image/hamburger_menu_icon.svg" />
          </button>
          <nav
            class="navbar navbar-expand-md navbar-light sl-navbar p-0 justify-content-center justify-content-md-start"
          >
            <div>
              <div class="collapse navbar-collapse" id="navbarNav">
                <ul class="navbar-nav nav-fill w-100">
                  <li
                    class="nav-item sl-nav-item"
                    v-for="sl in displayedServiceLines"
                    :key="sl.id"
                  >
                    <router-link
                      @click.native="clickSLRoute(sl)"
                      class="nav-link"
                      :class="[
                      sl.id === currentServiceLine.id
                        ? 'router-link-active'
                        : ''
                    ]"
                      :to="'/' + platformCategory + '/categories/' + sl.id"
                    >
                      <div class="p-3">{{ sl.name }} ({{ sl.services.length }})</div>
                    </router-link>
                  </li>
                  <li
                    class="nav-item sl-more-nav-item dropdown text-md-left text-center pl-md-5"
                    v-if="isMoreVisible"
                  >
                    <div
                      class="nav-link nav-item-dropdown m-3"
                      data-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded="false"
                    >
                      <span class="sub-dropdown">{{ moreSize }} more</span>
                      <div class="category-drop-down-arrow down ml-3 sub-dropdown" />
                    </div>
                    <div
                      class="dropdown-menu ml-md-4 container-fluid category-container more-dropdown-menu"
                      aria-labelledby="dropdownMenuButton"
                    >
                      <div v-for="sl in serviceLines" :key="sl.id">
                        <router-link
                          @click.native="clickMoreSLRoute(sl)"
                          :class="[
                          sl.id === currentServiceLine.id
                            ? 'router-link-active'
                            : ''
                        ]"
                          class="dropdown-item serviceline-dropdown-item"
                          :to="'/' + platformCategory + '/categories/' + sl.id"
                        >{{ sl.name }}</router-link>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </nav>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as CONSTANTS from "@/store/constants";
export default {
  name: "DisplaySubCategories",
  props: {
    serviceLines: Array,
    platformCategory: String,
    currentServiceLine: Object
  },
  computed: {
    displayedServiceLines() {
      return this.serviceLines.slice(0, CONSTANTS.NBR_SUB_CATEGORIES_IN_NAV);
    },
    isMoreVisible() {
      if (this.serviceLines && this.displayedServiceLines) {
        return this.serviceLines.length > this.displayedServiceLines.length;
      }
    },
    moreSize() {
      return this.serviceLines.length - this.displayedServiceLines.length;
    }
  },
  created() {
    this.clickMoreSLRoute(this.currentServiceLine);
  },

  methods: {
    clickSLRoute(sl) {
      //Emit that a ServiceLine is selected
      this.$emit("clickSLRoute", sl);
    },
    clickMoreSLRoute(sl) {
      //Remove the last element in the subcategories and add the selected service line
      //Provided the index is more than that is being displayed
      let index = this.serviceLines.indexOf(sl);
      if (index >= CONSTANTS.NBR_SUB_CATEGORIES_IN_NAV) {
        this.serviceLines.splice(this.serviceLines.indexOf(sl), 1);
        this.serviceLines.splice(2, 0, sl);
        this.clickSLRoute(sl);
      } else {
        this.clickSLRoute(sl);
      }
    }
  }
};
</script>

<style scoped>
.sl-container .router-link-active {
  color: var(--secondary-color) !important;
  border-bottom: 4px var(--secondary-color) solid;
  font-weight: bold;
  font-family: artifaktElementBold !important;
}

.sl-container .category-container .router-link-active {
  color: var(--secondary-color) !important;
  border-bottom: none;
  font-weight: bold;
  font-family: artifaktElementBold !important;
}

.sl-nav-item {
  min-width: 250px;
}
.sl-more-nav-item {
  min-width: 400px;
}

@media (max-width: 767px) {
  .sl-more-nav-item {
    min-width: 40px;
  }
}

.sl-navbar {
  padding-bottom: 0px !important;
}
.nav-link {
  font-size: 20px;
}

.category-drop-down-arrow {
  display: inline-block;
  position: absolute;
  width: 15px;
  height: 15px;
  background: transparent;
  text-indent: -9999px;
  border-top: 6px solid #000000;
  border-left: 6px solid #000000;
  text-decoration: none;
  color: transparent;
}

.category-drop-down-arrow.down {
  transform: rotate(-135deg);
  margin: 6px;
}

.nav-link[aria-expanded="true"] .category-drop-down-arrow {
  border-top: 6px solid #000;
  border-left: 6px solid #000;
}

.serviceline-dropdown-item {
  padding: 15px 15px 15px 30px;
  color: #000000 !important;
}

.serviceline-dropdown-item:hover {
  background: #bfbfff !important;
}

.navbar-toggler {
  border-color: #fff !important;
}

.more-dropdown-menu {
  overflow-y: scroll !important;
  max-height: 550px !important;
}

.toggle-sl-button:focus {
  outline: 0;
}

.category-container {
  z-index: 1001;
}
.sub-dropdown:hover{
  cursor: pointer;
}
</style>
